import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const BarclaysFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Barclays"
      slug="/lenders/mis-sold-barclays-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default BarclaysFinancePage
